import { render, staticRenderFns } from "./Ingredients.vue?vue&type=template&id=51d86803&scoped=true"
import script from "./Ingredients.vue?vue&type=script&lang=js"
export * from "./Ingredients.vue?vue&type=script&lang=js"
import style0 from "./Ingredients.vue?vue&type=style&index=0&id=51d86803&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d86803",
  null
  
)

export default component.exports